export default __webpack_public_path__ + "static/media/hubs-icon.d94abbbf.svg";